import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { InteractiveMap } from '../../components/interactiveMap';

export const InteractiveMapPage = () => {
  const { HomeStatics } = useSelector((state) => state.config);
  const [elementHeight, setElementHeight] = useState(0);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  useEffect(() => {
    function updateElementHeight() {
      const windowHeight = window.innerHeight;
      const searchBarHeight =
        windowHeight - document.documentElement.clientHeight;
      const elHeigtht = windowHeight - searchBarHeight;
      setElementHeight(elHeigtht);
    }

    updateElementHeight();

    window.addEventListener('resize', updateElementHeight);
    return () => window.removeEventListener('resize', updateElementHeight);
  }, []);

  return (
    <InteractiveMap
      url={HomeStatics.situmAvailable.url}
      height={elementHeight}
    />
  );
};
